// admin-tickets.js — admin support-ticket triage panel.
// Loaded by admin.js when the user has role=admin.
// Uses /api/tickets/admin/* endpoints.

const STATE = {
  tickets: [],
  summary: null,
  activeId: null,
  filterStatus: '',
  filterPriority: '',
};

function token() { return localStorage.getItem('gdbs_token') || ''; }

async function api(method, path, body) {
  const headers = { 'Content-Type': 'application/json' };
  if (token()) headers['Authorization'] = 'Bearer ' + token();
  const res = await fetch(path, {
    method, headers, body: body ? JSON.stringify(body) : undefined
  });
  if (!res.ok) throw new Error(`${method} ${path}: ${res.status}`);
  return res.json();
}

function escapeHtml(s) {
  if (!s) return '';
  return s.replace(/[&<>"']/g, c => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;','\'':'&#39;' }[c]));
}

async function loadSummary() {
  try {
    STATE.summary = await api('GET', '/api/tickets/admin/summary');
    renderSummary();
  } catch (e) {
    console.error('Ticket summary load failed', e);
  }
}

function renderSummary() {
  const c = document.getElementById('admin-tix-summary');
  if (!c) return;
  const s = STATE.summary;
  if (!s) { c.innerHTML = ''; return; }
  const tile = (label, value, color) => `
    <div class="atix-tile">
      <div class="atix-tile-label">${label}</div>
      <div class="atix-tile-value"${color ? ` style="color:${color}"` : ''}>${value}</div>
    </div>`;
  c.innerHTML =
    tile('Total', s.total) +
    tile('Open', s.open, '#93c5fd') +
    tile('In progress', s.inProgress, '#fbbf24') +
    tile('Waiting', s.waiting, '#c4b5fd') +
    tile('Resolved', s.resolved, '#6ee7b7') +
    tile('P1 active', s.p1, s.p1 > 0 ? '#fca5a5' : null) +
    tile('P2 active', s.p2, s.p2 > 0 ? '#fbbf24' : null);
}

async function loadList() {
  const listEl = document.getElementById('admin-tix-list');
  if (!listEl) return;
  listEl.innerHTML = '<div style="padding:20px;color:var(--text-dim,#94a3b8);">Loading...</div>';
  try {
    const q = new URLSearchParams();
    if (STATE.filterStatus) q.set('status', STATE.filterStatus);
    if (STATE.filterPriority) q.set('priority', STATE.filterPriority);
    const path = '/api/tickets/admin/all' + (q.toString() ? '?' + q : '');
    const res = await api('GET', path);
    STATE.tickets = res.tickets || [];
    renderList();
  } catch (e) {
    listEl.innerHTML = `<div style="padding:20px;color:var(--accent-red,oklch(60% 0.20 25));">${e.message}</div>`;
  }
}

function renderList() {
  const el = document.getElementById('admin-tix-list');
  if (!el) return;
  if (STATE.tickets.length === 0) {
    el.innerHTML = '<div style="padding:20px;color:var(--text-dim,#94a3b8);">No tickets match the filters.</div>';
    return;
  }
  el.innerHTML = STATE.tickets.map(t => `
    <div class="atix-card${t.id === STATE.activeId ? ' active' : ''}" data-id="${t.id}">
      <div class="atix-card-meta">
        <span class="gdbs-badge gdbs-badge-${t.status}">${t.status.replace('_', ' ')}</span>
        <span class="gdbs-badge gdbs-badge-${t.priority.toLowerCase()}" style="background:${priorityColor(t.priority)};color:#fff;">${t.priority}</span>
        <span>${t.module}</span>
      </div>
      <div class="atix-card-subject">${escapeHtml(t.subject)}</div>
      <div class="atix-card-meta">${escapeHtml(t.userEmail)} · ${new Date(t.updatedAt).toLocaleString()}</div>
    </div>`).join('');

  el.querySelectorAll('.atix-card').forEach(c =>
    c.addEventListener('click', () => openDetail(c.dataset.id)));
}

function priorityColor(p) {
  if (p === 'P1') return '#7f1d1d';
  if (p === 'P2') return '#92400e';
  if (p === 'P3') return '#1e3a5f';
  return '#374151';
}

async function openDetail(id) {
  STATE.activeId = id;
  renderList();
  const detail = document.getElementById('admin-tix-detail');
  detail.innerHTML = '<p style="color:var(--text-dim,#94a3b8);">Loading...</p>';
  try {
    const res = await api('GET', '/api/tickets/' + id);
    const t = res.ticket;
    detail.innerHTML = `
      <div style="display:flex;justify-content:space-between;align-items:start;flex-wrap:wrap;gap:10px;">
        <div>
          <div style="font-size:11px;color:var(--text-dim,#64748b);">Ticket ${t.id.slice(0,8)}</div>
          <h3 style="margin:4px 0 8px;color:var(--text,#e2e8f0);">${escapeHtml(t.subject)}</h3>
          <div style="font-size:11px;color:var(--text-dim,#94a3b8);">${escapeHtml(t.userEmail)} · ${t.module} · ${t.category} · ${t.tier}</div>
        </div>
        <div style="display:flex;gap:6px;flex-wrap:wrap;">
          <select id="atix-status" style="padding:5px;">
            ${['open','in_progress','waiting','resolved','closed'].map(s =>
              `<option value="${s}" ${s===t.status?'selected':''}>${s}</option>`).join('')}
          </select>
          <select id="atix-priority" style="padding:5px;">
            ${['P1','P2','P3','P4'].map(p =>
              `<option value="${p}" ${p===t.priority?'selected':''}>${p}</option>`).join('')}
          </select>
        </div>
      </div>

      ${t.context && Object.keys(t.context).length ? `
        <details style="margin-top:12px;font-size:11px;color:var(--text-dim,#94a3b8);">
          <summary style="cursor:pointer;">Captured context</summary>
          <pre style="background:var(--bg-input,var(--bg-alt,#051018));padding:8px;border-radius:4px;margin-top:6px;overflow-x:auto;">${escapeHtml(JSON.stringify(t.context, null, 2))}</pre>
        </details>` : ''}

      <div id="atix-kb-suggest" style="margin:12px 0;font-size:11px;color:var(--text-dim,#94a3b8);"></div>
      <div id="atix-canned" style="margin:12px 0;font-size:11px;display:flex;gap:6px;flex-wrap:wrap;"></div>


      <div style="margin:14px 0;padding:12px;background:var(--bg-input,var(--bg-alt,#051018));border-radius:5px;border-left:3px solid var(--accent,#4fc3f7);">
        <div style="font-size:11px;color:var(--text-dim,#94a3b8);margin-bottom:4px;">${escapeHtml(t.userEmail)} · ${new Date(t.createdAt).toLocaleString()}</div>
        <div style="white-space:pre-wrap;">${escapeHtml(t.body)}</div>
      </div>

      ${(t.messages || []).map(m => `
        <div style="margin:8px 0;padding:10px;background:${m.authorRole==='admin'?'color-mix(in oklch,var(--accent) 14%,transparent)':'var(--bg-alt,#0f1f33)'};border-radius:5px;${m.internal ? 'border:2px dashed #fbbf24;' : ''}">
          <div style="font-size:11px;color:var(--text-dim,#94a3b8);margin-bottom:3px;">
            ${m.authorRole === 'admin' ? 'Support' : 'User'} · ${new Date(m.createdAt).toLocaleString()}
            ${m.internal ? ' · <span style="color:#fbbf24">INTERNAL NOTE</span>' : ''}
          </div>
          <div style="white-space:pre-wrap;">${escapeHtml(m.body)}</div>
        </div>
      `).join('')}

      <div style="margin-top:14px;">
        <textarea id="atix-reply" placeholder="Reply to user..." maxlength="8000"
          style="width:100%;min-height:90px;"></textarea>
        <div style="margin-top:8px;display:flex;gap:8px;align-items:center;">
          <label style="font-size:11px;color:var(--text-dim,#94a3b8);display:flex;align-items:center;gap:4px;">
            <input type="checkbox" id="atix-internal"> Internal note (not visible to user)
          </label>
          <button class="btn btn-primary btn-sm" id="atix-send"><i class="fas fa-reply"></i> Send</button>
          <span id="atix-status-msg" style="color:var(--text-dim,#94a3b8);font-size:11px;"></span>
        </div>
      </div>

      ${t.status === 'resolved' || t.status === 'closed' ? '' : `
      <div style="margin-top:14px;padding-top:14px;border-top:1px solid var(--border,#1e3a5f);">
        <label style="font-size:11px;color:var(--text-dim,#94a3b8);">Resolution notes (visible to user)</label>
        <textarea id="atix-resolution" maxlength="4000"
          style="width:100%;min-height:60px;margin-top:4px;"></textarea>
        <button class="btn btn-sm" id="atix-resolve" style="margin-top:8px;"><i class="fas fa-check"></i> Mark resolved</button>
      </div>`}
    `;

    document.getElementById('atix-status').addEventListener('change', async e => {
      await api('PUT', `/api/tickets/admin/${id}/status`, { status: e.target.value });
      await loadSummary();
      await loadList();
    });
    document.getElementById('atix-priority').addEventListener('change', async e => {
      await api('PUT', `/api/tickets/admin/${id}/priority`, { priority: e.target.value });
      await loadList();
    });

    document.getElementById('atix-send').onclick = async () => {
      const text = document.getElementById('atix-reply').value.trim();
      if (!text) return;
      const internal = document.getElementById('atix-internal').checked;
      const btn = document.getElementById('atix-send');
      btn.disabled = true;
      try {
        await api('POST', `/api/tickets/${id}/reply`, { body: text, internal });
        document.getElementById('atix-status-msg').textContent = 'Sent.';
        await openDetail(id);
      } catch (e) {
        document.getElementById('atix-status-msg').textContent = 'Failed: ' + e.message;
      }
      btn.disabled = false;
    };

    const resolveBtn = document.getElementById('atix-resolve');
    if (resolveBtn) resolveBtn.onclick = async () => {
      const notes = document.getElementById('atix-resolution').value;
      await api('PUT', `/api/tickets/admin/${id}/status`, { status: 'resolved', resolutionNotes: notes });
      await loadSummary();
      await loadList();
      await openDetail(id);
    };

    suggestKBForTicket(t);
    renderCannedReplies(t, id);
  } catch (e) {
    detail.innerHTML = `<p style="color:var(--accent-red,oklch(60% 0.20 25));">Load failed: ${e.message}</p>`;
  }
}

export async function initAdminTickets() {
  document.querySelectorAll('.atab').forEach(b => {
    b.addEventListener('click', () => {
      document.querySelectorAll('.atab').forEach(x => x.classList.remove('active'));
      b.classList.add('active');
      document.querySelectorAll('.apanel').forEach(p => p.classList.add('hidden'));
      const target = document.getElementById('apanel-' + b.dataset.atab);
      if (target) target.classList.remove('hidden');
      if (b.dataset.atab === 'tickets') refresh();
    });
  });

  document.getElementById('btn-tix-refresh')?.addEventListener('click', refresh);
  document.getElementById('admin-tix-filter-status')?.addEventListener('change', e => {
    STATE.filterStatus = e.target.value; loadList();
  });
  document.getElementById('admin-tix-filter-priority')?.addEventListener('change', e => {
    STATE.filterPriority = e.target.value; loadList();
  });

}

async function refresh() {
  await loadSummary();
  await loadList();
}

// -----------------------------------------------------------------------------
// KB suggestion: match ticket text against /docs/ for "have you seen this article"
// -----------------------------------------------------------------------------
let _kbIndex = null;
async function loadKBSuggestions() {
  if (_kbIndex) return _kbIndex;
  try {
    const r = await fetch('/api/docs/guide', { headers: { 'Authorization': 'Bearer ' + (localStorage.getItem('gdbs_token') || '') }, cache: 'no-store' });
    if (!r.ok) throw new Error('no index');
    _kbIndex = await r.json();
  } catch { _kbIndex = { topics: [] }; }
  return _kbIndex;
}

async function suggestKBForTicket(t) {
  const container = document.getElementById('atix-kb-suggest');
  if (!container) return;
  const idx = await loadKBSuggestions();
  const text = (t.subject + ' ' + t.body + ' ' + t.module + ' ' + t.category).toLowerCase();
  const scored = (idx.topics || []).map(topic => {
    const title = topic.title.toLowerCase();
    const tokens = title.split(/\W+/).filter(w => w.length > 3);
    let score = 0;
    for (const tok of tokens) if (text.includes(tok)) score += 1;
    if (t.module && topic.id.includes(t.module)) score += 2;
    return { topic, score };
  }).filter(x => x.score > 0)
    .sort((a, b) => b.score - a.score)
    .slice(0, 3);

  if (scored.length === 0) { container.innerHTML = ''; return; }

  container.innerHTML = `
    <div style="color:var(--text-dim,#94a3b8);font-size:11px;margin-bottom:6px;"><i class="fas fa-book"></i> Knowledge-base articles that may apply:</div>
    <div style="display:flex;gap:6px;flex-wrap:wrap;">
      ${scored.map(s => `
        <button class="atix-kb-link" data-topic="${s.topic.id}"
          style="background:var(--bg-alt,#0f1f33);border:1px solid var(--border,#1e3a5f);color:var(--accent,#4fc3f7);padding:4px 10px;border-radius:14px;cursor:pointer;font-size:11px;">
          ${escapeHtml(s.topic.title)}
        </button>
      `).join('')}
    </div>`;
  container.querySelectorAll('.atix-kb-link').forEach(btn => {
    btn.addEventListener('click', () => {
      window.gdbsOpenDocs?.(btn.dataset.topic);
    });
  });
}

// -----------------------------------------------------------------------------
// Canned admin replies — common responses one click away
// -----------------------------------------------------------------------------
const CANNED_REPLIES = [
  { id: 'investigating', label: 'Investigating',
    body: 'Thanks for the report. We are investigating and will follow up shortly.' },
  { id: 'need_more', label: 'Need more info',
    body: 'To help diagnose, could you share:\n- Browser + OS\n- Steps to reproduce\n- Screenshot if applicable\n- Approximate timestamp of the issue (UTC)' },
  { id: 'wontfix_perf', label: 'By design (perf)',
    body: 'This is currently expected behavior — the solver enforces a 3-second budget per scan and trades some precision for response time. Bump the precision-tier slider to tier 2 or 3 if you need more accuracy.' },
  { id: 'validation_calibration', label: 'Substrate calibration explained',
    body: 'The validation suite computes a calibrated β_N using a GMDBS {3,5,7}-prime rational that reflects each device\'s operational fraction of the Troyon limit. The "Computed" column is the calibrated value; hover the verdict to see the raw trial-function δW and the substrate factor.' },
  { id: 'license_resync', label: 'License resync',
    body: 'Please sign out, sign back in, then refresh. That triggers a fresh JWT and license fetch. If the issue persists for >5 minutes after a Stripe purchase, let me know and I will resync manually.' },
];

function renderCannedReplies(t, ticketId) {
  const container = document.getElementById('atix-canned');
  if (!container) return;
  container.innerHTML = `
    <span style="color:var(--text-dim,#64748b);font-size:10px;text-transform:uppercase;letter-spacing:0.05em;align-self:center;">Canned:</span>
    ${CANNED_REPLIES.map(c => `
      <button class="atix-canned-btn" data-canned="${c.id}"
        style="background:var(--bg-alt,#0f1f33);border:1px solid var(--border,#1e3a5f);color:var(--text,#cbd5e1);padding:3px 9px;border-radius:12px;cursor:pointer;font-size:11px;">
        ${escapeHtml(c.label)}
      </button>
    `).join('')}`;
  container.querySelectorAll('.atix-canned-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const c = CANNED_REPLIES.find(x => x.id === btn.dataset.canned);
      if (!c) return;
      const replyEl = document.getElementById('atix-reply');
      if (replyEl) replyEl.value = c.body;
    });
  });
}
